import {
  forwardRef,
  Fragment,
  Ref,
  useImperativeHandle,
  useState,
} from 'react';
import { AddCustomerModalGroupRef } from '../../../types';
import { FilterRoute } from '@zonofi/zono-money-store';
import { CustomerSuccessModal } from './customer-success/customer-success-modal';
import { FilterModal } from '../../../components';
import { CustomerLocationModal } from './location-modal/customer-location-modal';

export const AddCustomerModalGroup = forwardRef(
  (props, ref: Ref<AddCustomerModalGroupRef>) => {
    const [showSuccessModal, setCustomerSuccessModal] =
      useState<boolean>(false);
    const [showFilter, setShowFilter] = useState<boolean>(false);
    const [showLocationModal, setShowLocationModal] = useState(false);

    useImperativeHandle(ref, () => ({
      openSuccessModal: () => setCustomerSuccessModal(true),
      openFilterModal: () => setShowFilter(true),
      opneLocationMoadal: () => setShowLocationModal(true),
    }));

    return (
      <Fragment>
        <CustomerSuccessModal
          open={showSuccessModal}
          onClose={() => setCustomerSuccessModal(false)}
        />
        <FilterModal
          route={FilterRoute.Customer}
          onClose={() => setShowFilter(false)}
          open={showFilter}
        />
        <CustomerLocationModal
          open={showLocationModal}
          onClose={() => setShowLocationModal(false)}
        />
      </Fragment>
    );
  }
);
